import { jsxs as i, jsx as o } from "react/jsx-runtime";
import { useBreakpointValue as r, HStack as t } from "@chakra-ui/react";
import { SgiLogo as a } from "../../../branding/SgiLogo/SgiLogo.mjs";
import { MySgiLogo as s } from "../../../branding/MySgiLogo/MySgiLogo.mjs";
const g = () => {
  const e = r({ base: !0, md: !1 }, { fallback: "md" });
  return /* @__PURE__ */ i(t, { spacing: { base: 2, md: 3 }, children: [
    /* @__PURE__ */ o(a, { width: { base: "32.3px", md: "100px" }, ...e && { isCondensed: !0 } }),
    /* @__PURE__ */ o(s, { type: "beta", orientation: "horizontal" })
  ] });
};
export {
  g as MySgiBranding
};
